module.exports = __webpack_public_path__ + "static/img/15baohudiqiu.879b8886.gif";